'use strict';require('normalize.css/normalize.css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/style/css.web.js
// module id = 206
// module chunks = 0